/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateAutomationMutationRequest,
  UpdateAutomationMutationResponse,
  UpdateAutomationPathParams,
  UpdateAutomation400,
} from '../types/UpdateAutomation'

function getUpdateAutomationUrl({
  id,
}: {
  id: UpdateAutomationPathParams['id']
}) {
  const res = {
    method: 'PUT',
    url: `/api/v1/automations/automations/${id}/` as const,
  }
  return res
}

/**
 * @description Override update to handle both regular JSON and multipart form data
 * @summary Update an automation
 * {@link /api/v1/automations/automations/:id/}
 */
export async function updateAutomation(
  { id }: { id: UpdateAutomationPathParams['id'] },
  data: UpdateAutomationMutationRequest,
  config: Partial<RequestConfig<UpdateAutomationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateAutomationMutationResponse,
    ResponseErrorConfig<UpdateAutomation400>,
    UpdateAutomationMutationRequest
  >({
    method: 'PUT',
    url: getUpdateAutomationUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
